import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Elements } from 'react-stripe-elements';
import { withSizes } from 'react-sizes';
import { PaymentWizardGift,PaymentForm } from "../index";
import GiftPanel from '../GiftPanel';

import {
  CheckoutContainer,
  Column,
  PageHeading,
  Heading,
  Description,
} from './styles';

const { PanelContainer, PanelImageContainer, PaymentInfo } = GiftPanel;

const mapSizesToProps = ({ width }) => ({
  isTablet: width >= 768,
});

@withSizes(mapSizesToProps)
class CheckoutGiftWrapper extends PureComponent {
  static propTypes = {
    isTablet: PropTypes.bool,
  };

  state = {
    form: null,
    price: 20,
  };

  setPriceAmount = price => {
    this.setState({
      price: Number(price),
    })
  };

  getForm = instance => {
    this.setState({
      form: instance,
    })
  };

  render() {
    const { getForm, setPriceAmount } = this;
    const { form, price } = this.state;
    const { isTablet } = this.props;

    return (
      <CheckoutContainer as="main">
        <Column>
          <PageHeading>
            <Heading>
              <span>Dayaxe</span> eGift Pass
            </Heading>
            <Description>Gift an experience they won&apos;t forget</Description>
          </PageHeading>
          {!isTablet && <PanelImageContainer />}
          <Elements>
            <PaymentForm>
              <PaymentWizardGift setFormikInstance={getForm} price={price} setPriceAmount={setPriceAmount} />
            </PaymentForm>
          </Elements>
          {!isTablet && <PaymentInfo total={price} price={price} product="eGift Card" formInstance={form} />}
        </Column>
        <Column>
          {isTablet && (
            <PanelContainer>
              <PanelImageContainer />
              <PaymentInfo total={price} price={price} product="eGift Card" formInstance={form} />
            </PanelContainer>
          )}
        </Column>
      </CheckoutContainer>
    );
  }
}

export default CheckoutGiftWrapper;
